import axios from "axios";
import { readSessionToken } from "./app.state.service";

export const setGlobalAuthorizationHeader = token => {
   if (token) {
       axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
   }
   else {
        delete axios.defaults.headers.common["Authorization"];
   }
}

/**
 * Re-applies the stored token to the global axios header when the app boots. The header lives in
 * page memory, so a tab that starts inside an existing session would otherwise send no default.
 *
 * @since NEXT_VERSION
 */
export const restoreGlobalAuthorizationHeader = () => {
    setGlobalAuthorizationHeader(readSessionToken());
}

export const setAuthHeader = () => {
    const token = readSessionToken();
    if(!token) {
        //throw "Login to access this feature";
        return null;
    }

    const config = {
        headers: {
            'Authorization' : `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    return config;
}

/**
 * Returns just the headers object for use with fetch API
 * Used by new service files (iqms, project, knowledge, skill)
 */
export const authHeader = () => {
    const token = readSessionToken();
    if(!token) {
        return {};
    }
    return {
        'Authorization' : `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}